import { useEffect, useState } from 'react';
import styles from './SelectPlan.module.scss';
import { SelectPlanCard } from './SelectPlanCard';
import { ContinueButton } from '../../../../components/ContinueButton/ContinueButton';
import { getCurrencySymbol } from '../../../../services/getCurrencySymbol';
import { useCurrency } from '../../../../providers/CurrencyProvider/useCurrency';

export const SelectPlan = ({ content, selectedPlan, setSelectedPlan }) => {
  const { currency } = useCurrency();
  const [footerText, setFooterText] = useState(null);
  const { title, selectedPlanText, plans, button } = content;

  const currencySymbol = getCurrencySymbol(currency);

  useEffect(() => {
    if (!plans || !plans.length || selectedPlan) return;

    // Найти популярный или fallback на первый
    const defaultIdx = plans.findIndex(plan => plan.popular) !== -1
      ? plans.findIndex(plan => plan.popular)
      : 0;

    setSelectedPlan(plans[defaultIdx]);
    setFooterText(plans[defaultIdx].text);
  }, [plans, selectedPlan, setSelectedPlan]);

  if (!plans || !plans.length || !selectedPlan) return null;

  const activeIdx = plans.findIndex(p => p === selectedPlan);

  return (
    <div className={styles.plans}>
      {title && <h2 className={styles.title} dangerouslySetInnerHTML={{ __html: title }} />}
      <div className={styles.selectPlans}>
        {plans.map((plan, idx) => (
          <SelectPlanCard
            key={idx}
            content={plan}
            currency={currencySymbol}
            status={idx === activeIdx ? 'active' : ''}
            selectedPlanText={selectedPlanText}
            onClick={() => {
              setSelectedPlan(plan);
              setFooterText(plan.text);
            }}
          />
        ))}
      </div>
      {selectedPlan.type === 'subscription' && (
        <div className={styles.text}>{renderFooterText(footerText, currencySymbol)}</div>
      )}
      <ContinueButton
        className={styles.button}
        onClick={() => {
          const target = document.getElementById('payment-method');
          if (target) {
            target.scrollIntoView({ behavior: 'smooth' });
          }
        }}
      >
        {button || 'Get my result'}
      </ContinueButton>
    </div>
  );
};

const renderFooterText = (text, currencySymbol) => {
  const parts = text.split(/<currency>(.*?)<\/currency>/g);
  return parts.map((part, idx) =>
    idx % 2 === 1 ? (
      <span key={idx} className="currencyCode">
        {currencySymbol} {part}
      </span>
    ) : (
      part
    )
  );
};
